import React from "react";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { ResourceCard } from "~/components/ui/resource-card";
import { coachQueryOptions } from "~/lib/query-options";

const parentRoute = getRouteApi("/_public/discovery/$username");

export const Route = createFileRoute("/_public/discovery/$username/resources/")(
  {
    loader: async ({ context, params }) => {
      const coach = await context.queryClient.ensureQueryData(
        coachQueryOptions.byUsername(params.username),
      );
      return { coach };
    },
    head: ({ loaderData }) => {
      const coach = loaderData?.coach;

      // If no coach, no profile, or no resources, emit noindex/nofollow
      if (!coach?.profile || !coach.resources?.length) {
        return {
          title: "Resources - Dream Coach Match",
          meta: [{ name: "robots", content: "noindex, nofollow" }],
        };
      }

      return {
        title: `Resources - ${coach.fullName} | Dream Coach Match`,
        meta: [
          {
            name: "description",
            content: `Resources and content from ${coach.fullName}`,
          },
        ],
      };
    },
    component: ResourcesPage,
  },
);

function ResourcesPage() {
  const { coach } = parentRoute.useLoaderData();

  if (!coach?.profile) {
    return <div className="p-6">Not found.</div>;
  }

  return (
    <div className="p-6">
      <div className="grid gap-8 md:grid-cols-2">
        {coach.resources?.length ? (
          coach.resources.map((resource) => (
            <ResourceCard
              className="h-full"
              key={resource.id}
              resource={resource}
              coachUsername={coach.username}
            />
          ))
        ) : (
          <p>No resources available.</p>
        )}
      </div>
    </div>
  );
}
